
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 14.4 14.4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.6.4a.4.4 0 01.8 0V14a.4.4 0 01-.8 0V.4z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.44 8h9.12c.795 0 1.44.645 1.44 1.44v1.92a1.44 1.44 0 01-1.44 1.44H1.44A1.44 1.44 0 010 11.36V9.44C0 8.645.645 8 1.44 8zm0 .8a.64.64 0 00-.64.64v1.92c0 .354.287.64.64.64h9.12a.64.64 0 00.64-.64V9.44a.64.64 0 00-.64-.64H1.44zM10.56 1.6H4.64A1.44 1.44 0 003.2 3.04v1.92c0 .795.645 1.44 1.44 1.44h5.92A1.44 1.44 0 0012 4.96V3.04a1.44 1.44 0 00-1.44-1.44zM4 3.04a.64.64 0 01.64-.64h5.92a.64.64 0 01.64.64v1.92a.64.64 0 01-.64.64H4.64A.64.64 0 014 4.96V3.04z","fill":"currentColor"}})])
          )
        }
      }
    